// currency
export const CURRENCY_LIST = [
  { flag: 'US', name: 'United States Dollar', abbreviation: 'USD', symbol: '$' },
  // { flag: 'VN', name: 'Việt Nam Đồng', abbreviation: 'VND', symbol: 'đ' },
  { flag: 'BG', name: 'EURO', abbreviation: 'EUR', symbol: '€' },
]
